// src/examples/Footer/index.js
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Chip com logótipo oficial (imagem)
function TechChip({ imgSrc, label, title, disabled }) {
  return (
    <MDBox
      component="span"
      role="listitem"
      title={title || label}
      display="inline-flex"
      alignItems="center"
      gap={0.75}
      px={1.25}
      mr={1}
      sx={({ palette }) => ({
        height: 28,
        lineHeight: 1,
        borderRadius: 999,
        bgcolor: disabled ? "rgba(0,0,0,0.03)" : "rgba(0,0,0,0.06)",
        border: `1px solid ${disabled ? "rgba(0,0,0,0.08)" : "rgba(0,0,0,0.1)"}`,
        color: palette.text.main,
        opacity: disabled ? 0.55 : 1,
      })}
    >
      <img
        src={imgSrc}
        alt={`${label} logo`}
        width={18}
        height={18}
        style={{ display: "block", objectFit: "contain" }}
      />
      <MDTypography variant="caption" color="text" fontWeight="medium" sx={{ lineHeight: 1 }}>
        {label}
      </MDTypography>
    </MDBox>
  );
}

TechChip.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};
TechChip.defaultProps = { title: "", disabled: false };

function Footer() {
  return (
    <MDBox
      role="contentinfo"
      width="100%"
      px={{ xs: 1, md: 2 }}
      py={0.75}
      sx={({ palette }) => ({
        background: palette.mode === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.9)",
        border: `1px solid ${
          palette.mode === "dark" ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.08)"
        }`,
        borderRadius: 12,
        boxShadow: "0 6px 12px rgba(0,0,0,0.06)",
      })}
    >
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1}
        sx={{ minHeight: 38 }}
      >
        <MDBox display="flex" alignItems="center" flexWrap="wrap" gap={1}>
          <MDTypography
            variant="caption"
            color="text"
            sx={{ mr: 1, fontWeight: 500, opacity: 0.9, whiteSpace: "nowrap" }}
          >
            JFB Gest - Gestão Interna
          </MDTypography>

          {/* <TechChip imgSrc="/logos/react.png" label="ReactJS" title="ReactJS" />
          <TechChip imgSrc="/logos/csharp.png" label="C#" title="C#" />
          <TechChip imgSrc="/logos/postgresql.png" label="PostgreSQL" title="PostgreSQL" />
          <TechChip imgSrc="/logos/jasper.png" label="Jasper Reports" title="Jasper Reports" /> */}
        </MDBox>

        <MDTypography variant="caption" color="text" sx={{ opacity: 0.85 }}>
          © {new Date().getFullYear()} JF Bebidas, S.A.
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

Footer.defaultProps = { company: { href: "", name: "" }, links: [] };
Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
};

export default Footer;
